export function initSwiper(selector) {

    import(/* webpackChunkName: "wp-swiper-bundle" */ 'swiper/bundle').then(SwiperModule => {

        const Swiper = SwiperModule.default;

        selector.forEach((element, i) => {

            const buttonPrev  = document.querySelectorAll('.teasers .swiper-button--prev');
            const buttonNext  = document.querySelectorAll('.teasers .swiper-button--next');

            const pocketOuterLeft  = document.querySelectorAll('.swiperPocket__outer--left')[i];
            const pocketInnerLeft  = document.querySelectorAll('.swiperPocket__inner--left')[i];
            const pocketOuterRight = document.querySelectorAll('.swiperPocket__outer--right')[i];
            const pocketInnerRight = document.querySelectorAll('.swiperPocket__inner--right')[i];

            const showPocket = () => {
                pocketOuterLeft.classList.add('js-active');
                pocketInnerLeft.classList.add('js-active');
                pocketOuterRight.classList.add('js-active');
                pocketInnerRight.classList.add('js-active');
            }

            const hidePocket = () => {
                pocketOuterLeft.classList.remove('js-active');
                pocketInnerLeft.classList.remove('js-active');
                pocketOuterRight.classList.remove('js-active');
                pocketInnerRight.classList.remove('js-active');
            }
    
            new Swiper(element, {
    
                loop: false,
                autoplay: false,
                slidesPerView: 1,
                spaceBetween: 30,
        
                navigation: {
                    prevEl: buttonPrev[i],
                    nextEl: buttonNext[i]
                },
    
                breakpoints: {
                    576: {
                        slidesPerView: 2
                    },
                    1025: {
                        slidesPerView: 3
                    }
                },

                on: {
                    slideChangeTransitionStart: function () {
                        showPocket();
                    },
                    slideChangeTransitionEnd: function () {
                        hidePocket();
                    },
                    touchStart: function () {
                        showPocket();
                    },
                    touchEnd: function () {
                        hidePocket();
                    },
                }
            });
        });    
    });
}